// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  PinMode,
} from "./types";

export default {
  deploymentId: __t.u32(),
  autoDeploy: __t.bool(),
  get pinMode() {
    return PinMode;
  },
  pinnedRef: __t.option(__t.string()),
};
